import React from "react"
import GravityFormForm from "@inspired-agency/gatsby-gravityforms-component"
import { useStaticQuery, graphql, navigate } from "gatsby"
import { lighten } from "polished"
import { toast } from "react-toastify"
import { Col, Container, Row } from "reactstrap"
import styled from "styled-components"
import vars from "styles/variables"
import { trackCustomEvent } from "gatsby-plugin-google-analytics"
import { find } from "lodash-es"

function Form({ pageId, data, handleFormSuccess, location, headerContent }) {
 
  // Log the new fragment data values
  console.log('Form Fragment Data:', {
    data
  })

  const { allGfForm } = useStaticQuery(
    graphql`
      query {
        allGfForm {
          edges {
            node {
              ...GravityFormComponent
            }
          }
        }
      }
    `
  )

  const backgroundBlue = data.blueBackgroundColour
  const title = data.title
  const { name, email } = location?.state || {}

  const handleSuccessInternal = ({ values, confirmations, dataType }) => {
    // Get the form based on it's id
    const formEntity = find(allGfForm.edges, {
      node: { formId: Number(data.type) },
    })

    // Get the form slug
    const { slug } = formEntity?.node || {}
    // Track event in GA
    trackCustomEvent({
      category: "form",
      action: "submission",
      label: slug || "Unknown",
    })

    toast.success(
      (confirmations instanceof Array && confirmations[0]?.message) ||
        "Thank you, we will be in touch soon."
    )

    // Currently there's no way for us to set property names or pass back the form name or id in Gravity Forms
    // instead we can only use the key value pairs passed back from the API. In this case
    // input 7 is the hidden field named 'Redirect To Additional Enquiry', if this field is present
    // and has a value of "redirect", then send the user to the additional enquiry form.
    if (data.type !== 6) {
      if (values.input_7 === "redirect") {
        const data = {
          state: {
            name: values.input_1,
            email: values.input_4,
          },
        }
        navigate("/additional-enquiry", data)
      }
    }
  }
  return (
    <FormWrapper
      className={`${
        [6, 7, 9, 10].includes(data.type) ? "bg-white py-4 px-4" : ""
      }`}
      style={{
        backgroundColor: backgroundBlue ? "#2F3E50" : "transparent",
        color: backgroundBlue ? "white" : "",
      }}
    >
      <Container className="px-lg-0">
        {(title && !data.titleContained) || data.sectionTitle && (
          <Row>
            <Col className="mt-4 mb-3">
              <h2 style={{ textAlign: "center" }}>{!data.titleContained ? title : ''}{data?.sectionTitle}</h2>
            </Col>
          </Row>
        )}
        {data.type === 6 && !data.hideTitle && (
          <Row>
            <Col>
              <h2>Get your FREE Quote</h2>
            </Col>
          </Row>
        )}
        {data.type === 7 && !data.hideTitle && (
          <Row>
            <Col>
              <h2>Get a FREE Brochure</h2>
            </Col>
          </Row>
        )}
        <Row className="h-100" style={{rowGap: '24px'}}>
          <Col xs="12" lg={
            (data?.promoImage && data.showImagePromo) || (data.benefits && data.benefits.length) ? 8 :
            (data.salesEmail || data.showroomContactDetails) ? 6 : 
            8 
          } className="d-flex">
            <StyledFormContainer
              className={`d-flex flex-column blue ${![6, 7, 9, 10].includes(data.type) ? 'with-padding' : ''}`}
            >
              {headerContent}
              <div className="px-0 px-sm-3">
                {title && data.titleContained && (
                  <h2 className="mb-0">{title}</h2>
                )}

                {data.description && <p>{data.description}</p>}
              </div>
              <GravityFormForm
                id={Number(data.type)}
                presetValues={{ input_5: name, input_6: email }}
                formData={allGfForm}
                successCallback={props => {
                  // Callback function passed to component
                  if (typeof handleFormSuccess === "function")
                    handleFormSuccess({ ...props })
                  // Internal function which runs on every form submission
                  const dataType = Number(data.type)
                  handleSuccessInternal({ ...props, dataType })
                }}
                captchaSize="normal"
                enablePostcodeSoftware={false}
                enableCompactAddress={false}
                enableLeadTracking={true}
              />
            </StyledFormContainer>
          </Col>
          {data.promoImage && data.showImagePromo && (
            <Col xs="12" lg="4" className="d-flex">
              <StyledImg className="d-none d-lg-block w-100 h-auto" src={data.promoImage.sourceUrl} alt={data.promoImage.alt} />
              {data.promoImageMobile && <StyledImg className="d-block d-lg-none w-100 h-auto" src={data.promoImageMobile.sourceUrl} alt={data.promoImageMobile.alt} />}
            </Col>
          )}
          
          {(data.salesEmail || data.showroomContactDetails) && (
            <Col xs="12" lg="6" className="d-flex">
              <StyledContactSection>
                {data.salesEmail && (
                  <div className="email-section">
                    {data.emailHeader && <h3>{data.emailHeader}</h3>}
                    {data.emailContnet && <p className="section-content">{data.emailContnet}</p>}
                    <div className="contact-item">
                      <img
                        src={require("assets/icons/email.svg").default}
                        alt=""
                        className="contact-icon"
                      />
                      <a href={`mailto:${data.salesEmail}`} className="email-link">
                        {data.salesEmail}
                      </a>
                    </div>
                  </div>
                )}
                
                {data.showroomContactDetails && data.showroomContactDetails.length > 0 && (
                  <div className="showroom-section">
                    {data.showroomHeader && <h3>{data.showroomHeader}</h3>}
                    {data.showroomContent && <p className="section-content">{data.showroomContent}</p>}
                    {data.showroomContactDetails.map((showroom, index) => (
                      <div key={index} className="showroom-item">
                        <h4>{showroom.showroomName}</h4>
                        
                        <div className="contact-item">
                          <img
                            src={require("assets/icons/pin.svg").default}
                            alt=""
                            className="contact-icon"
                          />
                          <a 
                            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(showroom.showroomAddress)}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="address-link"
                          >
                            {showroom.showroomAddress}
                          </a>
                        </div>

                        <div className="contact-item">
                          <img
                            src={require("assets/icons/phone.svg").default}
                            alt=""
                            className="contact-icon"
                          />
                          <a href={`tel:${showroom.showroomPhoneNumber}`} className="phone-link">
                            {showroom.showroomPhoneNumber}
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </StyledContactSection>
            </Col>
          )}
          
          {data.benefits && data.benefits.length > 0 && (
            <Col xs="12" lg="4" className="d-flex">
              <StyledBenefitsSection>
                <h3>The Trusted Window Experts</h3>
                <div className="benefits-grid">
                  {data.benefits.map((benefit, index) => (
                    <div key={index} className="benefit-item">
                      {benefit.benefitsIcon && (
                        <img
                          src={benefit.benefitsIcon.sourceUrl}
                          alt={benefit.benefitsIcon.altText || benefit.benefitsTitle}
                          className="benefit-icon"
                        />
                      )}
                      <div className="benefit-content">
                        <h4>{benefit.benefitsTitle}</h4>
                        <p>{benefit.benefitsText}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </StyledBenefitsSection>
            </Col>
          )}
        </Row>
      </Container>
    </FormWrapper>
  )
}

export default Form

const FormWrapper = styled.div`
  &.bg-white {
    background-color: #ffffff !important;
    color: black;
    border-radius: 8px;

    label {
      font-weight: 700;
    }
  }
`

const StyledImg = styled.img`
  border-radius:8px;
  object-fit:cover;
`

const StyledContactSection = styled.div`
  width: 100%;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  
  .contact-item {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 0.5rem;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .contact-icon {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
  
  .section-content {
    color: #000;
    margin-bottom: 20px;
    line-height: 1.6;
  }
  
  .email-section {
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #eee;
    
    h3 {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      color: ${vars.primary};
    }
    
    .email-link {
      color: #000;
      text-decoration: underline;
      font-size: 1.1rem;
      
      &:hover {
        color: #ff6600;
      }
    }
  }
  
  .showroom-section {
    h3 {
      font-size: 1.5rem;
      margin-bottom: 0.5rem;
      color: ${vars.primary};
    }
    
    .showroom-item {
      margin-bottom: 1.5rem;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      h4 {
        font-size: 1rem;
        font-style: normal;
        font-weight: 700;
        line-height: 1.5rem;
        margin-bottom: 0.5rem;
        color: #000;
      }
      
      .address {
        color: #666;
        margin: 0;
        line-height: 1.4;
      }
      
      .address-link {
        color: #666;
        text-decoration: underline;
        margin: 0;
        line-height: 1.4;
        
        &:hover {
          color: #ff6600;
        }
      }
      
      .phone-link {
        color: #000;
        text-decoration: underline;
        font-weight: 600;
        
        &:hover {
          color: #ff6600;
        }
      }
    }
  }
`

const StyledBenefitsSection = styled.div`
  width: 100%;
  padding: 24px;
  background: white;
  border-radius: 8px;
  
  h3 {
    font-size: 2rem;
    margin-bottom: 2rem;
    color: ${vars.primary};
    text-align: left;
  }
  
  .benefits-grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .benefit-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    gap: 12px;
    
    .benefit-icon {
      width: 60px;
      height: 60px;
      flex-shrink: 0;
      object-fit: contain;
      margin-bottom: 8px;
    }
    
    .benefit-content {
      text-align: left;
      h4 {
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        color: #000;
        line-height: 1.5rem;
      }
      
      p {
        font-size: 1rem;
        color: #666;
        margin: 0;
        line-height: 1.5rem;
      }
    }
  }
`

const StyledFormContainer = styled.div`
  width: 100%;

  h2 {
    font-size: 32px;
    line-height: 48px; /* 150% */
  }

  &.blue {
    background: white;
    color: black;
    border-radius: 8px;
    padding-bottom: 28px;
  }

  &.with-padding {
    padding: 24px 16px;
  }

  @media (max-width: ${vars.screen_xs_max}) {
    margin: 0;
  }

  .gravityform {
    &--id-8 {
      label {
        font-weight: 700;
      }

      .ginput_container {
        margin: 0 !important;
        input,
        textarea {
          border-radius: 4px;
          box-shadow: none;
          border: 1px solid #979797;
        }

        textarea {
          height: 160px;
        }
      }

      .gform_button {
      
        border-radius: 4px;
      }
    }

    &--id-6,
    &--id-7,
    &--id-8 {
      .gform_button {
        width: 100%;
      }
    }
    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        margin-bottom: 15px !important;
      }
    }

    label {
      margin-bottom: 0.5rem;
      display: inline-block;
    }

    .gfield_visibility_hidden {
      display: none;
    }

    .gravityform__field,
    .gravityform__postcode_software,
    .gform_footer {
      padding-right: 15px;
      padding-left: 15px;
      position: relative;

      @media (max-width: ${vars.screen_xs_max}) {
        padding: 0;
      }
    }

    .gravityform__field__input {
      width: 100%;
    }

    .gravityform__field__input,
    .gravityform__postcode_software_textfield {
      height: 44px;
      padding: 0 15px;
    }

    .gravityform__field__input__textarea {
      height: 100px;
      padding: 15px;
    }

    .gform_footer {
      text-align: right;
    }

    .gravityform__button,
    .gravityform__postcode_software_button {
      min-width: 230px;
      display: inline-block;
      text-decoration: none;
      cursor: pointer;
      text-align: center;
      line-height: 1;
      border: none;
      color: ${vars.white};
      opacity: 1;
      transition: ease-in-out 200ms;
      background: ${vars.secondary};
      padding: 15px;

      &:hover {
        background: ${lighten(0.05, vars.secondary)};
      }

      &:disabled,
      &[disabled] {
        opacity: 0.5;
      }
    }

    .gravityform__postcode_software_button {
      background: ${vars.blue};
      &:hover {
        background: ${lighten(0.05, vars.blue)};
      }

      &.gravityform__postcode_software_button_enter_manually {
        background: ${vars.lightBlue};
        color: ${vars.primary};
        &:hover {
          background: ${lighten(0.05, vars.lightBlue)};
        }
      }
    }

    .gravityform__postcode_software_container {
      position: relative;
      .gravityform__postcode_software_input_group {
        display: flex;
        align-items: center;

        @media (max-width: ${vars.screen_md_max}) {
          display: block;

          button {
            display: inline-block;
            min-width: 50%;
          }
        }

        .gravityform__postcode_software_textfield {
          width: 100%;
        }
      }
      .gravityform__postcode_software_address_list {
        position: absolute;
        max-height: 200px;
        overflow-y: scroll;
        width: 100%;
        z-index: 999;
        background: ${vars.grey_100};
        color: ${vars.black};
        padding: 0.5rem 15px;

        .gravityform__postcode_software_address_list_item {
          cursor: pointer;
          padding: 0.5rem 0;
          &:hover {
            color: ${vars.primary};
          }
        }
      }
      .gravityform__postcode_software_error {
        color: ${vars.red};
        margin-top: 0.5rem;
      }
    }

    .gravityform__error_message {
      /* position: absolute; */
      color: ${vars.red};
      margin-top: 10px;
      /* left: 15px;
      bottom: -20px; */
    }

    .gravityform__error_inform {
      color: ${vars.red};
      text-align: center;
    }

    .gravityform__field__hidden {
      display: none;
    }

    .hidden-label {
      label {
        display: none;
      }
    }
  }

  .gform_confirmation_message {
    text-align: center;
  }

  .gravityform__postcode_software_selected_address {
    padding: 1.5rem;
    color: ${vars.black};
    background: ${vars.grey_100};
    margin-top: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .gravityform__postcode_software_button_remove_address {
    background: ${vars.red};
    color: ${vars.white};
    text-decoration: none;
    cursor: pointer;
    text-align: center;
    line-height: 1;
    border: none;
    transition: ease-in-out 200ms;
    padding: 5px 10px;
    margin-left: 15px;

    &:hover {
      background: ${lighten(0.05, "crimson")};
    }
  }
`
